import React, {Fragment, memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";
import {Link, useLocation, useNavigate, useOutlet} from "react-router-dom";
import KeepAlive, { useKeepaliveRef } from "keepalive-for-react";
import Sidenav from "../../Sidenav";
import brandWhite from "../../../assets/images/logos/darwynn/darwynn_logo.svg";
import brandDark from "../../../assets/images/logos/darwynn/dark_logo.svg";
import LocalStorage from "../../../utils/LocalStorage";
import {LOCAL_STORAGE_ITEMS} from "../../../constants";
import Configurator from "../../Configurator";
import MDBox from "../../../components/MDBox";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import {
    get_auth_info,
    get_notification,
    Logout,
    onErrorAlert, onSuccessAlert,
    setCache,
    setLayout,
    setOpenConfigurator
} from "../../../actions";
import {useDispatch, useSelector} from "react-redux";
import DashboardNavbar from "../../Navbars/DashboardNavbar";
import {
    Alert, Backdrop,
    ButtonGroup,
    Chip,
    FormControl,
    FormControlLabel,
    FormLabel,
    Paper, Radio,
    RadioGroup,
    Tooltip
} from "@mui/material";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import Fade from "@mui/material/Fade";
import MDButton from "../../../components/MDButton";
import Box from "@mui/material/Box";
import './TabStyles.css';
import ListItemText from "@mui/material/ListItemText";
import {ClearOutlined} from "@mui/icons-material";
import CancelIcon from '@mui/icons-material/Cancel';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CachedIcon from '@mui/icons-material/Cached';
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import MDTypography from "../../../components/MDTypography";
import {unstable_batchedUpdates} from "react-dom";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import BackspaceIcon from '@mui/icons-material/Backspace';
import TabItem from "./TabItem";
import Switch from "@mui/material/Switch";

const colorToClassNameMap = {
    primary: 'skin-amethyst',
    info: 'skin-peter-river',
    success: 'skin-nephritis',
    warning: 'skin-carrot',
    error: 'skin-pomegranate',
    dark: 'skin-graphite'
};

import InfoIcon from '@mui/icons-material/Info';
import {styled} from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import {useTranslation} from "react-i18next";


const ScrollingText = styled("div")`
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  width: 100%;

  span {
    display: inline-block;
    padding-left: 100%;
    animation: ${(props) => `scroll ${props.animationDuration}s linear infinite`};
  }

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

const AuthLayout = memo(() => {
    const [animationDuration, setAnimationDuration] = useState(20); // default duration
    const textRef = useRef(null);
    const location = useLocation();
    const dispatch = useDispatch()
    const [notification,setNotification] = useState(false)
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const transparentSidenav = useSelector(state => state?.common?.transparentSidenav,(prev, next) => prev === next)
    const miniSidenav = useSelector(state => state?.common?.miniSidenav,(prev, next) => prev === next)
    const whiteSidenav = useSelector(state => state?.common?.whiteSidenav,(prev, next) => prev === next)
    const sidenavColor = useSelector(state => state?.common?.sidenavColor,(prev, next) => prev === next)
    const openConfigurator = useSelector(state => state?.common?.openConfigurator,(prev, next) => prev === next)
    // const nav = useNavigate()
    const navigate = useNavigate();
    const aliveRef = useKeepaliveRef();
    const manuCache = useSelector(state => state?.common?.cache,(prev, next) => prev === next)
    const [notificationContent,setNotificationContent] = useState({})
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const buttonRef = useRef(null);
    const alertRef = useRef(null); // 用于引用Alert组件
    const sidenavFixed = useRef(false);
    const [alertOffset, setAlertOffset] = useState(50); // initial height of Alert
    const [sidenavHeight, setSidenavHeight] = useState(`calc(100% - ${alertOffset}px)`);
    const {t, i18n} = useTranslation();
    const [isSidenavFixed, setSidenavFixed] = useState(false);

    const [alertHeight, setAlertHeight] = useState(50);
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        const alertMessage = LocalStorage.getItem('alert')
        if (alertMessage) {
            dispatch(onSuccessAlert(t(alertMessage)));
            LocalStorage.removeItem('alert'); // 清除存储的提示信息
        }
    }, []);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClearAll = () => {
        setAnchorEl(null)
        setTabs(prevTabs => [prevTabs[0]]); // 清除除了第一个 tab 外的所有 tab
        if (aliveRef.current) {
            aliveRef.current.cleanOtherCache();
        }
    };


    useEffect(() => {
        if (textRef.current && notificationContent!=={} && notificationContent?.noticeTitle) {
            const textWidth = textRef.current.offsetWidth; // Get the width of the text
            const containerWidth = textRef.current.parentNode.offsetWidth; // Get the width of the container (screen)

            // Define the desired scrolling speed (e.g., 100 pixels per second)
            const scrollingSpeed = 100; // pixels per second

            // Calculate the duration based on the total scroll distance
            const totalScrollDistance = textWidth + containerWidth; // Total distance the text needs to travel
            const newDuration = totalScrollDistance / scrollingSpeed; // Time = Distance / Speed

            setAnimationDuration(newDuration);
        }
    }, [notificationContent]);

    const handleClose = () => {
        setAnchorEl(null);
    };
    const formatLabel = (path) => {
        const lastSlashIndex = path.lastIndexOf('/');
        const label = path.substring(lastSlashIndex + 1);
        const formattedLabel = label.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        return formattedLabel
    };


    const { pathname } = useLocation();
    const [showBanner,setShowBanner] = useState(false)

    const [tabs, setTabs] = useState([{
        key: location.pathname,
        path: location.pathname,
        label: formatLabel(location.pathname)
    }]);

    const [activeTab, setActiveTab] = useState(location.pathname);


    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (params.get("clearCache")) {
            aliveRef.current?.removeCache("/app/support/ticket_management");
        }


    }, [location.search]);

    useEffect(() => {
        setLoading(false)
        navigate(location.pathname)
        if (manuCache && tabs.length >= Number(process.env.REACT_APP_CACHE_LIMIT) && !tabs.some(tab=>tab.path === location.pathname)) {
            dispatch(setOpenConfigurator( false))
            if (buttonRef.current) {
                buttonRef.current.click(); // 手动触发点击事件
            }
            navigate(tabs[0].path);

            dispatch(onErrorAlert(`${t('The maximum number of open tabs is')} ${String(process.env.REACT_APP_CACHE_LIMIT)}. ${t('Please close any unnecessary tabs or select the automatic cache management mode')}.`))
            return;
        }
        const newPath = location.pathname;
        const newTabs = tabs.filter(tab => tab.path !== newPath); // 移除当前路径的 tab（如果存在）
        const currentTab = tabs.find(tab => tab.path === newPath);



        setTabs(prevTabs => {

            let updatedTabs;
            if (currentTab) {
                updatedTabs = [currentTab, ...newTabs];
            } else {
                const newTab = {
                    key: newPath,
                    path: newPath,
                    label: formatLabel(newPath),
                };
                updatedTabs = [newTab, ...newTabs];
            }

            // 限制 updatedTabs 的长度为 2
            if ( !manuCache && updatedTabs.length > Number(process.env.REACT_APP_CACHE_LIMIT)) {

                handleDelete(updatedTabs[updatedTabs.length-1].path)();
                //updatedTabs = updatedTabs.slice(0, 2); // 只保留前两个 tab
            } else if(manuCache && updatedTabs.length > Number(process.env.REACT_APP_CACHE_LIMIT)) {

            }
            return updatedTabs;
        });
        setActiveTab(newPath);


    }, [location.pathname]);


    useEffect(() => {

    }, [tabs]);

    const handleTabClick = (path) => {
        if(path !== location.pathname){
            setLoading(true)
        }
        setAnchorEl(null)
        if (path === '/app/account') {
            // LocalStorage.setItem("selectedAccountTab",2);
            navigate(`${path}?tab=${LocalStorage.getItem('accountTab')}`);
        } else {
            navigate(path);
        }
    };


    const handleReload = useCallback((path) => () => {
        if (aliveRef.current) {
            aliveRef.current.refresh(path);
        }
    }, [aliveRef.current]);

    const handleDelete = useCallback((path) => () => {
        setTabs(prevTabs => prevTabs.filter(tab => tab.path !== path));
        if (path === activeTab) {
            const remainingTabs = tabs.filter(tab => tab.path !== path);
            if (remainingTabs.length > 0) {
                navigate(remainingTabs[remainingTabs.length - 1].path);
            } else {
                navigate('/');
            }
        }
        if (aliveRef.current) {
            aliveRef.current.removeCache(path);
        }
    }, [navigate, tabs, activeTab, aliveRef.current]);

    const [cacheEnabled, setCacheEnabled] = useState(true);

    const cacheKey = useMemo(() => location.pathname, [location.pathname]);


    const outlet = useOutlet();
    const handleConfiguratorOpen = () => dispatch(setOpenConfigurator(!openConfigurator));

    const onError = (msg)=> {
        navigate('/')
        dispatch(onErrorAlert(msg))
    }

    const onNotificationSuccess = (notification) => {
        if(notification.inactive){
            setNotification(false)
            LocalStorage.setItem('notification',false)
        } else {
            setNotification(true)
            LocalStorage.setItem('notification',true)
            let obj = {...notification}
            if(notification.noticeContent){
                const htmlString = notification.noticeContent;
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = htmlString;
                const objContent = tempDiv.innerText;
                obj.noticeContent = objContent
            }
            setNotificationContent(obj)
        }

    }

    const onCheckSuccess = (role,status) => {
        setShowBanner(!status)
        if(!LocalStorage.getToken() || !LocalStorage.getItem('username')){
            return navigate('/')
        }
        dispatch(setLayout("dashboard"))
    }

    const handleCache = (event) => {
        event.stopPropagation(); // 阻止事件冒泡
        const value = event.target.value === 'true'; // 将字符串 'true' 转换为布尔 true
        dispatch(setCache(value)); // 只更新 manuCache 的值，不关闭菜单
    };

    useLayoutEffect(() => {


        const axiosPost = async () => {
            await dispatch(get_notification(onNotificationSuccess,onError))
        }
        Boolean(JSON.parse(LocalStorage.getItem('notification'))) &&  axiosPost().then()


    }, []);

    useLayoutEffect(() => {

        const axiosPost = async () => {
            await dispatch(get_auth_info(onCheckSuccess,onError))
        }
        axiosPost().then()


    }, [pathname]);



    const configsButton = (
        <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="3.25rem"
            height="3.25rem"
            bgColor="white"
            shadow="sm"
            borderRadius="50%"
            position="fixed"
            right="2rem"
            bottom="2rem"
            zIndex={99}
            color="dark"
            sx={{cursor: "pointer"}}
            onClick={handleConfiguratorOpen}
        >
            <IconButton>
                <SettingsIcon/>
            </IconButton>
            {/*<SettingsIcon fontSize="small" color="inherit">*/}
            {/*  settings*/}
            {/*</SettingsIcon>*/}

        </MDBox>
    );


    const handleSidenavPosition = useCallback((entries) => {
        const [entry] = entries;
        const visibleHeight = entry.isIntersecting ? entry.boundingClientRect.height : 0;
        setAlertHeight(visibleHeight);
        setSidenavFixed(!entry.isIntersecting); // Fixed position when Alert is not intersecting
    }, []);

    useEffect(() => {
        setSidenavHeight(`calc(100% - ${alertOffset}px)`);
    }, [alertOffset]);


    useEffect(() => {
        if (notification && alertRef.current) {
            const observer = new IntersectionObserver(handleSidenavPosition, {
                root: null,
                threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0],
            });
            observer.observe(alertRef.current);

            return () => observer.disconnect();
        }
    }, [notification, handleSidenavPosition]);


    return (
        <React.Fragment>
            <div style={{display:'flex',flexDirection:'column'}}></div>
            {notification && (
                <div ref={alertRef} style={{ overflow: "hidden", width: "100%" }}>
                    <Alert
                        severity="warning"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            "& .MuiAlert-message": {
                                flexGrow: 1,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                            },
                        }}
                        onClose={() => {
                            setNotification(false);
                            localStorage.setItem('notification', false);
                        }}
                    >
                        <ScrollingText animationDuration={animationDuration}>
                            <span ref={textRef}>{`${notificationContent?.noticeTitle}: ${notificationContent?.noticeContent}`}</span>
                        </ScrollingText>
                    </Alert>
                </div>
            )}



            <Sidenav
                setLoading={setLoading}
                style={{ height: sidenavHeight }}
                fixed={isSidenavFixed || !notification}
                alertHeight={notification ? alertHeight : 0}
                color={sidenavColor}
                brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandWhite : brandDark}
                brandName={
                    LocalStorage.getItem('role') === 'customer'
                        ? `${t(`Welcome`)} ${LocalStorage.getItem('ownerId')}`
                        : `${t(`Welcome`)} ${LocalStorage.getItem('username')}`
                }
            />
            <Configurator/>
            {configsButton}



            <MDBox
                sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
                    p: 3,
                    position: "relative",

                    [breakpoints.up("xl")]: {
                        marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
                        transition: transitions.create(["margin-left", "margin-right"], {
                            easing: transitions.easing.easeInOut,
                            duration: transitions.duration.standard,
                        }),
                    },
                })}

            >
                <DashboardNavbar />

                {showBanner && !checkPermission(PERMISSION_DICT.QueryOwnerInfo) && <MDBox my={2}>
                    <Fade in={showBanner} mountOnEnter unmountOnExit>
                        <Alert variant="filled" severity="warning"
                               action={
                                   <MDButton color="dark" variant={'gradient'} size="small" onClick={()=>{
                                       LocalStorage.setItem("selectedAccountTab",2);
                                       navigate("/app/account?tab=2")
                                   }}>
                                       {t('Link')}
                                   </MDButton>
                               }
                        >
                            {t('You have not added a credit card yet. Please')}{' '}
                            <Link onClick={
                                LocalStorage.setItem("selectedAccountTab",2)
                            } to="/app/account?tab=2" style={{ color: 'red', textDecoration: 'underline !important' }}>
                                {t('add a credit card')}
                            </Link>
                            {' '}{t('first to access the following services')}.
                        </Alert>
                    </Fade>
                </MDBox>}

                <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',width:'100%'}}>

                    <LayoutGroup>
                        <div className={`tabbed ${colorToClassNameMap[sidenavColor] || ''} round`}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                alignItems: 'flex-end',
                                flexWrap: 'nowrap',
                                listStyle: 'none',
                                p: 0.5,
                                m: 0,
                            }}
                                 component="ul">

                                {tabs.map((tab,index) => (
                                    <TabItem
                                        tabsLength={tabs.length}
                                        index={index}
                                        key={tab.key}
                                        tab={tab}
                                        isActive={tab.path === activeTab}
                                        onClick={() => handleTabClick(tab.path)}
                                        onReload={(event) => {
                                            event.stopPropagation();
                                            handleReload(tab.path)();
                                        }}
                                        onDelete={(event) => {
                                            event.stopPropagation();
                                            handleDelete(tab.path)();
                                        }}
                                    />
                                ))}
                            </Box>
                        </div>
                    </LayoutGroup>

                    <Card
                        variant="outlined"
                        sx={{
                            display: 'flex',
                            flexDirection:'row',
                            borderBottomRightRadius: 0,
                            borderBottomLeftRadius: 0
                        }}
                    >
                        <Fragment>
                            <Tooltip title={t("SettingBar.Clear Other tabs")} placement={'top'}>
                                <IconButton
                                    onClick={handleClearAll}
                                    size={'medium'}
                                    aria-label="add an alarm">
                                    <BackspaceIcon />
                                </IconButton>
                            </Tooltip>

                        </Fragment>
                        <Fragment>
                            <Tooltip title={t("SettingBar.ALL Tags")} placement={'top-start'}>
                                <IconButton
                                    ref={buttonRef}
                                    onClick={handleMenuClick}
                                    size={'medium'}
                                    color="primary"
                                    sx={{
                                        color: 'gray', // 默认颜色为灰色
                                        '&:hover': {
                                            color: 'primary.main', // 鼠标悬停时变为主题的 primary 颜色
                                            bgcolor: 'transparent' // 可以选择性地设置悬停时的背景色，如果不需要可以去掉这行
                                        }
                                    }}
                                    aria-label="add an alarm">
                                    <ReadMoreIcon />
                                </IconButton>
                            </Tooltip>
                            <Menu

                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleClose}
                                slotProps={{
                                    paper: {
                                        elevation: 0,
                                        sx: {
                                            padding:3,
                                            overflow: 'visible',
                                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                            mt: 1.5,
                                            '& .MuiAvatar-root': {
                                                width: 32,
                                                height: 32,
                                                ml: -0.5,
                                                mr: 1,
                                            },
                                            '&::before': {
                                                content: '""',
                                                display: 'block',
                                                position: 'absolute',
                                                top: 0,
                                                right: 14,
                                                width: 10,
                                                height: 10,
                                                bgcolor: 'background.paper',
                                                transform: 'translateY(-50%) rotate(45deg)',
                                                zIndex: 0,
                                            },
                                        },
                                    },
                                }}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                                <MDBox display="flex" justifyContent="space-between" alignItems="center" lineHeight={1}>
                                    <FormControl>
                                        <FormLabel sx={{display:'flex',textAlign:'center' ,alignItems:'center'}}>
                                            <MDTypography variant={'h5'} sx={{marginRight:1}}>{t('SettingBar.Cache Mode')}</MDTypography>
                                            <Tooltip title={`${t('SettingBar.The maximum number of tabs is')} ${String(process.env.REACT_APP_CACHE_LIMIT)}.`}>
                                                <InfoIcon/>
                                            </Tooltip>
                                        </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={manuCache ? 'true' : 'false'}
                                            onChange={handleCache}
                                        >
                                            <Tooltip title={`${t('SettingBar.When the number of tabs exceeds')} ${String(process.env.REACT_APP_CACHE_LIMIT)}, ${t('SettingBar.remove the least recently used tabs')}`}><FormControlLabel value='false' control={<Radio />} label={t("SettingBar.Automatic")} /></Tooltip>
                                            <Tooltip title={`${t('SettingBar.Manually close unnecessary tabs.')}`}><FormControlLabel value='true' control={<Radio />} label={t("SettingBar.Manually")} /></Tooltip>
                                        </RadioGroup>
                                    </FormControl>
                                </MDBox>

                                <Divider variant="middle"/>

                                {tabs.map((tab) => <MenuItem key={tab.label}  onClick={() => handleTabClick(tab.path)}>
                                    <ListItemText>
                                        <MDTypography variant={'h6'}>{`${t(`Sidebar.${tab.label}`)}`}</MDTypography>
                                    </ListItemText>
                                    {
                                        tabs.length >1 && <IconButton onClick={(event) => {
                                            event.stopPropagation(); // 阻止事件冒泡
                                            handleDelete(tab.path)();
                                        }} size={'small'} variant="body2" sx={{ color: 'text.secondary' }}>
                                            <CancelIcon />
                                        </IconButton>
                                    }

                                </MenuItem>)


                                }
                                <Divider variant="middle"/>
                                <MDButton
                                    onClick={handleClearAll}
                                    rel="noreferrer"
                                    variant="gradient"
                                    color={sidenavColor}
                                    fullWidth
                                >
                                    {t('SettingBar.close non-current tabs')}
                                </MDButton>



                            </Menu>
                        </Fragment>
                    </Card>



                </div>

                <MDBox mt={-2.5} style={{ visibility: loading ? 'hidden' : 'visible' }}>
                    <KeepAlive
                        activeName={cacheKey}
                        max={100}
                        strategy={'PRE'}
                        cache={cacheEnabled}
                        aliveRef={aliveRef}
                    >
                        {loading ? <React.Fragment /> : outlet}
                    </KeepAlive>
                </MDBox>


            </MDBox>


        </React.Fragment>

    );
});

export default AuthLayout